import { useEntitiesContext, EntityInstance } from '../context';
import { useEntityEdrContextSafe } from '../context/EntityEdrContext';
import { Dispatch, SetStateAction, useEffect } from 'react';

export const useActiveEntityStates = () => {
  // Use EntitiesContext (now includes all entity functionality)
  const context = useEntitiesContext();
  const selectedEntity = context?.selectedEntity;
  const setSelectedEntity = context?.setSelectedEntity;

  // Get EDR data availability from EntityEdrContext
  const edrContext = useEntityEdrContextSafe();
  const hasEdrData = !!(
    edrContext?.edrData?.crowdstrike || edrContext?.edrData?.microsoft_defender
  );

  const updateEntityState = (
    entity: EntityInstance,
    setEntityState: Dispatch<SetStateAction<EntityInstance | undefined>>,
    edrAvailable: boolean,
  ) => {
    const { edrPayload, edrConfigData } = entity || {};

    setEntityState?.((prevState: EntityInstance | undefined) => ({
      ...prevState,
      showIsolateEntity:
        !!edrPayload?.entity_id &&
        edrConfigData?.enabled &&
        edrConfigData?.edr_action_enabled &&
        edrAvailable, // Only show if EDR data is actually available
      // NOTE: excludedEntitiesVariables is now built in EntitiesContext
      // This hook only manages EDR-related state
    }));
  };

  useEffect(() => {
    if (selectedEntity && setSelectedEntity) {
      updateEntityState(selectedEntity, setSelectedEntity, hasEdrData);
    }
    /**
     * Note: selectedEntity, setSelectedEntity, and updateEntityState are intentionally excluded
     * from dependencies. We only want to re-run when specific entity properties change,
     * not when the parent object reference changes or when the setter/function references change.
     * This prevents unnecessary re-renders while ensuring the effect runs when entity data updates.
     */
  }, [selectedEntity?.edrPayload, selectedEntity?.edrConfigData, hasEdrData]);
};
